<template>
  <v-container fluid fill-height grid-list-lg>
    <v-layout class="text-xs-center" justify-center align-center>
      <v-layout column>
        <v-flex>
          <img src="../../public/img/message-sent-5.png" style="height:25vh" />
        </v-flex>
        <v-flex class="font-weight-black display-1">
          Thank you for joining!
        </v-flex>

        <br />

        <v-flex>
          <div>
            We sent an email to <strong>{{ userEmail }}</strong> to verifiy your
            account.
          </div>
          <div>
            You can use the button below to resend the email.
          </div>
        </v-flex>
        <v-flex>
          <v-btn color="primary" @click="sendEmail"
            >Resend Verification Email</v-btn
          >
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user", "auth"]),
    userEmail() {
      return this.user.email;
    }
  },
  methods: {
    async sendEmail() {
      if (this.user != undefined) {
        try {
          await this.auth.verifyEmail(this.user);
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  mounted() {
    this.sendEmail();
    this.usercheck = setInterval(async () => {
      await this.user.reload();
      if (this.user.emailVerified) {
        this.$router.push({ name: "home" });
      }
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.usercheck);
  }
};
</script>
